import React from 'react';

export const OrderHeader = ({ onToDateClick }) => (
  <div className="flex flex-row  w-full my-4 text-center text-[#9E9E9E] text-base mx-auto">
    <button className="w-[10%] " onClick={onToDateClick}>to</button>
    <div className="w-[16%] ">team members</div>
    <div className="w-[20%] ">order</div>
    <div className="w-[43%] ">place</div>
    <div className="w-[11%] ">finish</div>
  </div>
); 